import { render, staticRenderFns } from "./mainAdminAreaChartVideo.vue?vue&type=template&id=374d4456&scoped=true"
import script from "./mainAdminAreaChartVideo.vue?vue&type=script&lang=js"
export * from "./mainAdminAreaChartVideo.vue?vue&type=script&lang=js"
import style0 from "./mainAdminAreaChartVideo.vue?vue&type=style&index=0&id=374d4456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374d4456",
  null
  
)

export default component.exports